// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3PO77","fileBtn":"File_fileBtn__3sCnM","closeBtn":"File_closeBtn__Te-CQ","fileSelected":"File_fileSelected__1XJO3","disabled":"File_disabled__33FOd"};